import { Divider } from '@mui/material';
import { SparkTextField } from 'sharedComponents/SparkForm';
import MemorySectionHeader from '../MemorySectionHeader';

function MemoryBasicDetails() {
  return (
    <>
      <MemorySectionHeader headerText='Tell us more about this Knowledge Source' />
      <SparkTextField
        name='name'
        label='Name'
        placeholder='Knowledge Source Title'
        size={12}
        showCounter={true}
        maxNumber={50}
      />
      <SparkTextField
        name='shortDescription'
        label='Short Description'
        placeholder='Memory Description'
        size={12}
        multiline={true}
        rows={3}
        showCounter={true}
        maxNumber={150}
      />
      <Divider
        sx={{ width: '100%', marginBottom: '20px', marginTop: '20px' }}
      />
      <MemorySectionHeader headerText='Overview' />
      <SparkTextField
        name='detailedDescription'
        label='Detailed Description'
        placeholder='Memory Description'
        size={12}
        multiline={true}
        rows={3}
        showCounter={true}
        maxNumber={1000}
      />
    </>
  );
}

export default MemoryBasicDetails;
